import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Rx";
import { Router } from "@angular/router";
import { Http, Response, Headers, RequestOptions } from "@angular/http";
import { Cookie } from "ng2-cookies/ng2-cookies";
import { apiUrl } from "./../config";

import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";

@Injectable()
export class LoginService {
  cookies: Object;
  data: Object;
  options: RequestOptions;
  constructor(private http: Http, private router: Router) {
    this.cookies = Cookie.getAll();
  }

  login(username: string, password: string): Observable<any> {
    // var url = 'http://localhost/deutz1/public/logins';
    //var obj = { username: username, password: password };
    var body = btoa(username + "--" + password);

    //var url = 'http://localhost/deutz1/public/logins/'+body;
    var url = apiUrl + "/logins/" + body;
    console.log(url, 5600);
    // var json = JSON.stringify({"username":username,"password":password}); //'json="json"+json1="json1"';

    //   const headers: Headers = new Headers();
    // //  headers.append("Access-Control-Allow-Origin", "*");
    //   //headers.append("Access-Control-Allow-Credentials", "true");
    //   //headers.append("Access-Control-Allow-Methods", "GET, HEAD, OPTIONS, POST, PUT, DELETE");
    //   //headers.append("Content-Type", "application/json,application/x-www-form-urlencoded");
    //   //headers.append("Access-Control-Request-Headers", "Content-type,X-Requested-With,Origin,accept");

    //   const options = new RequestOptions({
    //     headers: headers
    //   });

    return this.http.get(url).map(res => {
      const data = res.json();
      //console.log(data);
      return data;
    });
  }

  isLogin() {
    if (this.cookies["TokenKey"] != undefined) {
      this.router.navigate(["dashboard"]);
    } else {
      this.router.navigate([""]);
    }
    //  return this.cookies['TokenKey'];
  }
}



// WEBPACK FOOTER //
// C:/wamp64/www/duetz.repos/angular4/src/app/_services/login.service.ts